import { getChannel } from "asos-web-secure-script-container";
import { asosGlobalNamespace } from "@template/constants";

const eventNames = [
  "signal.profile.ready",
  "tracking.asosBag.pageLoad",
  "tracking.asosBag.addItem",
  "tracking.productList.pageLoad",
  "tracking.productList.saveForLater",
  "tracking.productPage.addToBag",
  "tracking.productPage.saveForLater",
  "tracking.productPage.pageLoad"
];

const setupEvents = () => {
  const { port } = getChannel();

  eventNames.forEach(eventName => {
    window[asosGlobalNamespace].eventBus.addListener(eventName, data => {
      port.postMessage({ type: "event", eventName, data });
    });
  });
};

export default setupEvents;
